module.exports = __webpack_public_path__ + "static/media/PrivacyNotice.9fe4013c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/PrivacyNotice.pdf
// module id = 389
// module chunks = 0